import { useOutlet, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { Formik } from "formik";
import { SnackbarProvider } from "notistack";
import PayrollSetup from "../Pages/PayrollSetup/PayrollSetup";
import PayrollEntry from "../Pages/PayrollEntery/PayrollEntry";
import EmployeeManagement from "../Pages/EmployeeManagement/EmployManagement";
import EmployeePayrollMappingForm from "../Pages/PayrollEntery/PayPeriodSetup/PayPeriodData/EmployeePayrollMappingForm";

const Layout = () => {

    const params = useParams();
    const outlet = useOutlet();

    const {
        menuId,
        popupID,
        payrollEmpId,
    } = params;
    let ComponentToRender = null;

    if (menuId && !outlet) {
        const normalizedMenuId = menuId.toLowerCase().replace(/^0x/, '');

        if (normalizedMenuId === "010000000000000000000000000000000345") {
            ComponentToRender = <PayrollSetup />;
        } else if (normalizedMenuId === "010000000000000000000000000000000346") {
            // Open PayrollForm directly if both IDs exist
            if (payrollEmpId && popupID) {
                ComponentToRender = (
                    <SnackbarProvider
                        maxSnack={3}
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                        autoHideDuration={3000}
                    >
                        <Formik
                            initialValues={{
                                corporation: "",
                                account: "",
                                accountId: "",
                                frequency: "",
                                frequencyId: "",
                                payFrom: null,
                                payTo: null,
                                payDate: null,
                                wage: [],
                                addAndDeductions: [],
                                eeAndErTaxes: [],
                                importPayrollType: null,
                            }}
                            enableReinitialize
                            onSubmit={() => { }}
                        >
                            <EmployeePayrollMappingForm
                                row={{ raw: { PayrollEmpID: payrollEmpId }, statusText: "Matched", skipPayrollDetailsLoad: true }}
                                setStep={() => { }}
                                setSelectedRow={() => { }}
                            />
                        </Formik>
                    </SnackbarProvider>
                );
            } else {
                ComponentToRender = <PayrollEntry />;
            }

        } else if (normalizedMenuId === "010000000000000000000000000000000331") {
            ComponentToRender = <EmployeeManagement />;
        }
    }

    return (
        <Box height={"100%"} p={0.5}>
            <Box height={"100%"}>
                {outlet || ComponentToRender}
            </Box>
        </Box>
    );
};
// job menu id = 010000000000000000000000000000000334
// report menu id = 010000000000000000000000000000000336
export default Layout;